'use client';

import { type FC, useEffect } from 'react';
import { hotjar } from 'react-hotjar';

export const HotjarScript: FC = () => {
    useEffect(() => {
        if (process.env['NODE_ENV'] === 'development') {
            return;
        }

        const timeout = setInterval(() => {
            if (
                'dataLayer' in window &&
                Array.isArray(window.dataLayer) &&
                window.dataLayer?.some((data) => data?.[0] === 'consent' && data?.[2]?.analytics_storage === 'granted')
            ) {
                clearInterval(timeout);

                hotjar.initialize({ id: 2950168, sv: 6 });
            }
        }, 2000);
    }, []);

    return null;
};
